import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Settings } from 'src/app/model/settings.model';
import { SitesettingsService } from 'src/app/services/settings/sitesettings.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-editsetting',
  templateUrl: './editsetting.component.html',
  styleUrls: ['./editsetting.component.css']
})
export class EditsettingComponent implements OnInit {

  keyids: string;
  setting: Settings;

  constructor(private route: ActivatedRoute, private router: Router, private settingService:
    SitesettingsService) {
    this.keyids = this.route.snapshot.params.keyid;
  }

  ngOnInit() {
    this.getSettingById();
  }

  getSettingById() {
    this.settingService.getSettingById(this.keyids).subscribe(
      (data: any) => {
        this.setting = data;
      });
  }

  submitSettingForm(form : NgForm)
  {
    form.value.id = this.keyids;
    console.log(form.value);
    this.settingService.updateSettings(form.value).subscribe(
      (data : any) => {
        if(data == true)
        {
          this.router.navigate(['/portalsettings']);
        }
        else
        {
          alert("An Error Occured");
        }
      }
    )
  }

}
